module.exports = __webpack_public_path__ + "img/cast_news_nonews@2x.503f85e9.png";